export default __webpack_public_path__ + "static/media/instaHover.2a5193c6.svg";